import { render, staticRenderFns } from "./OnTheStage.vue?vue&type=template&id=c95e43a8&scoped=true&"
import script from "./OnTheStage.vue?vue&type=script&lang=js&"
export * from "./OnTheStage.vue?vue&type=script&lang=js&"
import style0 from "./OnTheStage.vue?vue&type=style&index=0&id=c95e43a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95e43a8",
  null
  
)

export default component.exports